import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState
} from 'react'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { useAuth } from '../Auth/AuthContext'
import { api } from '../../services/api'
import {
  getComponentsWithQuantity,
  getPrice,
  getQuantity
} from '../../utils/auxFunc'
// import { Product } from '../../entities/product'
import moment from 'moment'
import { useConfig } from '../Config/ConfigContext'

const CartContext = createContext()

export const useCart = () => useContext(CartContext)

// ----- API TOAST-----
const Toast = Swal.mixin({
  // toast: true,
  position: 'center',
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true
})

export const CartContextProvider = ({
  defaultValue = JSON.parse(window.localStorage.getItem('cartMonaco')) || [],
  children
}) => {
  const [cart, setCart] = useState(defaultValue)
  // const [timer, setTimer] = useState(null);
  const [show, setShow] = useState(false)
  const timeInterval = useRef()
  const { userData, auth } = useAuth()
  const { config } = useConfig()
  const navigate = useNavigate()

  const switchSideCart = async () => {
    try {
      if (!show) {
        const res = await api.cart.eliminateDuplicateProducts(
          userData.clientId,
          userData.clientPriceListId
        )
        const cartAPI = await res.json()
        if (!res.ok) {
          throw new Error('Problemas al recuperar el carrito')
        }
        setCart(cartAPI.items)
      }
      setShow(!show)
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'No se pudo recuperar el carrito',
        text: 'Intente nuevamente'
      })
    }
  }

  const initTimer = (minutes) => {
    clearInterval(timeInterval.current)
    let eventTime = moment().add(minutes, 'm')
    const interval = 1000

    timeInterval.current = setInterval(countdown, interval)

    function countdown() {
      const now = moment()
      const duration = moment.utc(eventTime?.diff(now)).format('mm:ss')

      if (duration.includes('00:00')) {
        clearInterval(timeInterval.current)
        clear()
      }
    }
  }

  // ----- API addToCart -----
  const addToCart = async (product) => {
    // console.log({ newProduct })
    // const normalizedProduct = new Product(
    //   newProduct.idProduct,
    //   newProduct.name,
    //   newProduct.img,
    //   newProduct.description,
    //   newProduct.price,
    //   newProduct.dolarValue,
    //   newProduct.category
    // )
    // newProduct.components.forEach((component) =>
    //   normalizedProduct.components.push(component)
    // )

    let cartAux = JSON.parse(JSON.stringify(cart))

    const data = {
      cartItems: getComponentsWithQuantity(product.components),
      user: userData,
      clientId: userData.clientId
    }

    api.cart
      .addProducts(data)
      .then((data) => {
        if (data.status === 200) {
          Toast.fire({
            customClass: {
              title: 'productAdded',
              icon: 'productAddedIcon'
            },
            icon: 'success',
            title: 'Productos Agregados'
          })

          if (cartAux !== null) {
            if (
              !cartAux?.some(
                (cartProduct) => cartProduct.idProduct === product.idProduct
              )
            ) {
              cartAux = [...cartAux, product]
            } else {
              let productIndex = cartAux.findIndex(
                (cartProduct) => cartProduct.idProduct === product.idProduct
              )

              product.components.forEach((component) => {
                if (
                  !cartAux[productIndex].components.some(
                    (element) => element.idComponent === component.idComponent
                  )
                ) {
                  cartAux[productIndex].components.push(component)
                } else {
                  cartAux[productIndex].components.find(
                    (element) => element.idComponent === component.idComponent
                  ).quantity = component.quantity
                }
              })
            }
          } else {
            cartAux = []
            cartAux.push(product)
          }

          setCart(cartAux)
          initTimer(config.BUY_TIMER)
        }
      })
      .catch((error) => console.log(error))
  }

  // ----- API addToComponent
  const addToComponent = async (idProduct, idComponent, quantity) => {
    let cartAux = await JSON.parse(JSON.stringify(cart))
    let isFailed = await api.cart
      .addToComponent(idComponent, userData)
      .then((data) => {
        if (data.status === 400) {
          Swal.fire({
            icon: 'error',
            title: 'Stock insuficiente',
            text: 'No es posible agregar más unidades'
          })
          return true
        }
        cartAux
          .find((product) => product.idProduct === idProduct)
          .components.find(
            (component) => component.idComponent === idComponent
          ).quantity = quantity

        setCart(cartAux)
        initTimer(config.BUY_TIMER)
        return false
      })
      .catch((err) => {
        Swal.fire({
          icon: 'error',
          title: 'Se ha producido un error',
          text: 'Intentelo más tarde'
        })
        return true
      })

    return isFailed
  }

  // ----- API removeToComponent -----
  const removeToComponent = (idProduct, idComponent, quantity) => {
    let cartAux = JSON.parse(JSON.stringify(cart))
    api.cart
      .removeToComponent(idComponent, userData)
      .then((data) => {
        if (data.status !== 200) {
          navigate('/', { replace: true })
          Swal.fire({
            icon: 'error',
            title: 'Se ha producido un error',
            text: 'Intentelo más tarde'
          })

          return
        }

        cartAux
          .find((product) => product.idProduct === idProduct)
          .components.find(
            (component) => component.idComponent === idComponent
          ).quantity = quantity

        setCart(cartAux)
        initTimer(config.BUY_TIMER)
      })
      .catch((err) => {
        console.log('Error - ', err.message)
        navigate('/', { replace: true })
        Swal.fire({
          icon: 'error',
          title: 'Se ha producido un error',
          text: 'Intentelo más tarde'
        })
      })
  }

  // ----- API renmoveProductById ----
  //Eliminar producto completo, con todos sus componentes
  const removeByProductId = (id) => {
    let cartAux = JSON.parse(JSON.stringify(cart))

    api.cart
      .removeProduct(id, userData)
      .then((data) => {
        if (data.status !== 200) {
          Swal.fire({
            icon: 'error',
            title: 'Se ha producido un error',
            text: 'Intentelo más tarde'
          })
          return
        }

        const newCart = cartAux.filter((product) => product.idProduct !== id)
        setCart(newCart)
        initTimer(config.BUY_TIMER)
      })
      .catch((err) => {
        Swal.fire({
          icon: 'error',
          title: 'Se ha producido un error',
          text: 'Intentelo más tarde'
        })
      })
  }

  // ----- API removeByComponentId -----
  // Eliminar el item especifico por id
  const removeByComponentId = async (ids) => {
    let cartAux = [...cart]

    await api.cart.removeComponent(ids.idComponent, userData).then((data) => {
      if (data.status !== 200) {
        Swal.fire({
          icon: 'error',
          title: 'Se ha producido un error',
          text: 'Intentelo más tarde'
        })
        return
      }
      const componentsUpdated = cartAux
        .find((product) => product.idProduct === ids.idProduct)
        .components.filter(
          (component) => component.idComponent !== ids.idComponent
        )

      componentsUpdated.length === 0
        ? //eliminar producto completo del cart cuando los componentes sean 0
          removeByProductId(ids.idProduct)
        : // o actualizar los componentes disponibles, asignando los componentes actualizados
          (cartAux.find(
            (product) => product.idProduct === ids.idProduct
          ).components = componentsUpdated)

      setCart(cartAux)
      initTimer(config.BUY_TIMER)
    })
  }

  const getTotalByComponents = () => {
    const totalComponents = cart?.map((product) =>
      product.components.reduce((acc, component) => acc + component.quantity, 0)
    )
    return totalComponents
  }

  const getTotalQuantity = () => {
    const total = getTotalByComponents().reduce(
      (acc, quantity) => acc + quantity,
      0
    )
    return total
  }

  const getTotalAmountByComponents = () => {
    const totalComponentsAmount = cart?.map((product) =>
      product.components?.reduce((acc, component) => {
        const componentPrice = getPrice(
          product.volumePrices,
          product.price,
          getQuantity(product)
        )
        return acc + component.quantity * componentPrice * product.dolarValue
      }, 0)
    )
    return totalComponentsAmount
  }

  const getTotalAmount = () => {
    const total = getTotalAmountByComponents()?.reduce(
      (acc, amount) => acc + amount,
      0
    )
    return total
  }

  // ----- API emptyCart -----
  const clear = () => {
    api.cart.emptyCart(userData).then((data) => {
      if (data.status !== 200) {
        Swal.fire({
          icon: 'error',
          title: 'Se ha producido un error',
          text: 'Intentelo más tarde'
        })
        return
      }
      setCart([])
      clearInterval(timeInterval.current)
    })
  }

  // ----- API getCart -----
  const getCart = useCallback(() => {
    api.cart
      .getCart(userData)
      .then((response) => response.json())
      .catch((err) => console.log(err))
      .then(({ items }) => {
        if (items?.length > 0) {
          setCart(items)
        }
      })
  }, [userData])

  useEffect(() => {
    if (userData.status) {
      getCart()
    }

    if (!auth) {
      setCart([])
    }
  }, [auth, getCart, userData.status])

  return (
    <CartContext.Provider
      value={{
        cart,
        show,
        switchSideCart,
        addToCart,
        addToComponent,
        removeToComponent,
        removeByProductId,
        removeByComponentId,
        getCart,
        getTotalQuantity,
        getTotalByComponents,
        getTotalAmountByComponents,
        getTotalAmount,
        clear
      }}
    >
      {children}
    </CartContext.Provider>
  )
}

export default CartContext
